/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';

/**
 * 
 * @export
 * @interface MonthlyOrderMetrics
 */
export interface MonthlyOrderMetrics {
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetrics
     */
    year: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetrics
     */
    month: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyOrderMetrics
     */
    currencyCode: string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetrics
     */
    orderCount: number;
    /**
     * 
     * @type {Amount}
     * @memberof MonthlyOrderMetrics
     */
    orderAmount: Amount;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetrics
     */
    supplierCount: number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyOrderMetrics
     */
    storeCount: number;
}

/**
 * Check if a given object implements the MonthlyOrderMetrics interface.
 */
// @ts-ignore
export function instanceOfMonthlyOrderMetrics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "year" in value;
    isInstance = isInstance && "month" in value;
    isInstance = isInstance && "currencyCode" in value;
    isInstance = isInstance && "orderCount" in value;
    isInstance = isInstance && "orderAmount" in value;
    isInstance = isInstance && "supplierCount" in value;
    isInstance = isInstance && "storeCount" in value;

    return isInstance;
}

// @ts-ignore
export function MonthlyOrderMetricsFromJSON(json: any): MonthlyOrderMetrics {
    return MonthlyOrderMetricsFromJSONTyped(json, false);
}

// @ts-ignore
export function MonthlyOrderMetricsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonthlyOrderMetrics {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'year': json['year'],
        'month': json['month'],
        'currencyCode': json['currency_code'],
        'orderCount': json['order_count'],
        'orderAmount': AmountFromJSON(json['order_amount']),
        'supplierCount': json['supplier_count'],
        'storeCount': json['store_count'],
    };
}

// @ts-ignore
export function MonthlyOrderMetricsToJSON(value?: MonthlyOrderMetrics | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'year': value.year,
        'month': value.month,
        'currency_code': value.currencyCode,
        'order_count': value.orderCount,
        'order_amount': AmountToJSON(value.orderAmount),
        'supplier_count': value.supplierCount,
        'store_count': value.storeCount,
    };
}

